<template>
  <div class="slide-layout">
    <a class="ctrl up" @click="up">
      <slot name="up" />
    </a>
    <div :style="layoutStyle" class="continure">
      <div v-for="(iscreen, index) in screens" :key="index" :style="itemStyle" class="item">
        <slot name="item" :data="iscreen" :index="index" />
      </div>
    </div>
    <slot name="foot" :data="screens" :index="index" />
    <a class="ctrl next" @click="next">
      <slot name="next" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    screens: {
      default: () => [],
      type: Array
    },
    current: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      index: this.current
    }
  },
  computed: {
    left () {
      return this.index / this.screens.length * 100 + '%'
    },
    layoutStyle () {
      return {width: this.screens.length + '00%', transform: `translateX(-${this.left})`}
    },
    itemStyle () {
      return {width: 1 / this.screens.length * 100 + '%'}
    }
  },
  watch: {
    current (newVal) {
      this.index = newVal
    }
  },
  methods: {
    next () {
      this.index++
      if (this.index === this.screens.length) {
        this.index = 0
      }
    },
    up () {
      this.index--
      if (!~this.index) {
        this.index = this.screens.length - 1
      }
    }
  }
}
</script>

<style scoped>
.slide-layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.item {
  height: 100%;
  float: left;
  position: relative;
}

.ctrl {
  position: absolute;
  top: 50%;
  z-index: 9;
}

.up {
  left: 0;
}

.next {
  right: 0;
}

.continure {
  overflow: hidden;
  transition: transform .5s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/Slide/index.vue